import type { DataMode } from "../types";

export interface BrowserConfigInput {
  hostname: string;
  requestedDataMode?: string;
  supabaseUrl?: string;
  supabaseKey?: string;
  loginEmailHash?: string;
  localRestUrl?: string;
  localAiUrl?: string;
}

export interface BrowserConfig {
  dataMode: DataMode;
  supabaseUrl: string;
  supabaseKey: string;
  loginEmailHash: string;
  localRestUrl: string;
  localAiUrl: string;
}

export function resolveDataMode(input: Pick<BrowserConfigInput, "hostname" | "requestedDataMode" | "supabaseUrl" | "supabaseKey">): DataMode {
  const hasSupabase = Boolean(input.supabaseUrl && input.supabaseKey);
  const isLocalHost = ["127.0.0.1", "localhost", "::1"].includes(input.hostname);
  const requested = input.requestedDataMode || "";

  if (requested === "local" || (!hasSupabase && isLocalHost && requested !== "supabase")) {
    return "local";
  }

  return hasSupabase ? "supabase" : "missing";
}

export function getBrowserConfig(): BrowserConfig {
  const supabaseUrl = window.CRM_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL || "";
  const supabaseKey = window.CRM_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "";
  const loginEmailHash = window.CRM_LOGIN_EMAIL_SHA256 || import.meta.env.VITE_CRM_LOGIN_EMAIL_SHA256 || "";
  const requestedDataMode = window.CRM_DATA_MODE || import.meta.env.VITE_CRM_DATA_MODE || "";
  const localRestUrl = window.CRM_LOCAL_REST_URL || import.meta.env.VITE_LOCAL_REST_URL || "http://127.0.0.1:55431";
  const localAiUrl = window.CRM_LOCAL_AI_URL || import.meta.env.VITE_LOCAL_AI_URL || "http://127.0.0.1:55433";

  return {
    dataMode: resolveDataMode({
      hostname: window.location.hostname,
      requestedDataMode,
      supabaseUrl,
      supabaseKey,
    }),
    supabaseUrl,
    supabaseKey,
    loginEmailHash: loginEmailHash.trim().toLowerCase(),
    localRestUrl,
    localAiUrl,
  };
}

export function canShowCrm(dataMode: DataMode, hasSession: boolean): boolean {
  return dataMode === "local" || (dataMode === "supabase" && hasSession);
}
